import React from "react";
import { Link } from "react-router-dom";
import "./UnderConstruction.css";
import constructionGif from "../assets/images/Underconstruction.gif";

function UnderConstruction() {
  return (
    <div className="construction-page">

      <div className="construction-wrapper">

        <img
          src={constructionGif}
          alt="Under Construction"
          className="construction-image"
        />

        <h1 className="construction-title">
          This Page is Under Construction
        </h1>

        <p className="construction-description">
          We are currently working on this project. Please check back later.
        </p>

        <p className="construction-hint">
          Meanwhile, feel free to explore my other projects.
        </p>

        {/* Progress Bar */}
        <div className="construction-progress">
          <div className="construction-progress-bar"></div>
        </div>

        {/* Back Button */}
        <Link to="/projects" className="back-projects-btn">
          ← Back to Projects
        </Link>

      </div>

    </div>
  );
}

export default UnderConstruction;